module.exports = __webpack_public_path__ + "media/images/flags/1x1/lva-6cc60c4df37f8a87022f64309faa2478.svg";